export enum PReservationStatusIndicatorSize {
  MEDIUM = 'medium',
  SMALL = 'small',
}
